import script from "./dataStatistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./dataStatistics.vue?vue&type=script&lang=ts&setup=true"

import "./dataStatistics.vue?vue&type=style&index=0&id=107c0c68&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107c0c68"]])

export default __exports__